module.exports = __webpack_public_path__ + "img/hakuna_p02_img02.39be89b7.jpg";